<template>
  <div>
    <el-row>
      <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="{ span: 12, offset: 0 }">
        <ul>
          <li>供&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;应&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;商：{{ titleData[0].SUPPLIER_NAME }}</li>
          <li>送&nbsp;&nbsp;货&nbsp;&nbsp;日&nbsp;&nbsp;期：{{ titleData[0].SEND_DAY }}</li>
          <li>地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：{{ titleData[0].GYS_ADDRESS }}</li>
        </ul>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="{ span: 12, offset: 0 }" :xl="{ span: 12, offset: 0 }">
        <ul>
          <li>订&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ID&nbsp;：{{ orderId }}</li>
          <li>订&nbsp;&nbsp;单&nbsp;&nbsp;总&nbsp;&nbsp;金&nbsp;&nbsp;额：{{ titleData[0].TOTAL_GYS_FEE }}</li>
          <li>送&nbsp;货&nbsp;日&nbsp;期&nbsp;：{{ titleData[0].SEND_DAY }}</li>
        </ul>
      </el-col>
    </el-row>
    <!-- <el-row>
            <el-col>
                <p>订单编号：{{this.orderCode}}</p>
            </el-col>
        </el-row> -->
    <el-row>
      <el-col>
        <el-table border stripe :data="tableData" style="margin-top:20px">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column label="产品编码" prop="PRODUCT_CODE"></el-table-column>
          <el-table-column label="产品名称" prop="SHORT_NAME" min-width="100"></el-table-column>
          <el-table-column label="品牌" prop="BRAND" min-width="100"></el-table-column>
          <el-table-column label="规格" prop="SPECIFICATION" min-width="100"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT"></el-table-column>
          <el-table-column label="单价" prop="REAL_PRICE"></el-table-column>
          <el-table-column label="不含税单价" prop="BEFORE_TAX_PRICE"></el-table-column>
          <el-table-column label="税率" prop="TAX_RATE"></el-table-column>
          <el-table-column label="订购数量" prop="PRODUCT_COUNT"></el-table-column>
          <el-table-column label="实收数量" prop="REAL_COUNT"></el-table-column>
          <el-table-column label="送货数量" prop="NEED_COUNT"></el-table-column>
          <el-table-column label="总金额" prop="TOTAL_FEE"></el-table-column>
          <el-table-column label="不含税总金额" prop="PRODUCT_FEE_BEFORE_TAX"></el-table-column>
          <el-table-column label="备注" prop="PRODUCT_COMMENT"></el-table-column>
          <el-table-column label="操作" min-width="130">
            <template slot-scope="scope">
              <el-button type="text" @click="openEditDialog(scope.row)">修改</el-button><br>
              <el-button type="text" @click="showUploadBatch(scope.row)" size="small">上传批次报告
              </el-button><br>
              <el-button v-show="scope.row.BATCH_REPORT_ID !== 0" size="small" type="text"
                @click="downloadBatch(scope.row.BATCH_REPORT_ID)">查询批次报告</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-button @click="modifyOrder" style="float: left;margin-top: 20px" type="primary" v-if="userPriceType == 2">
          修改</el-button>
        <el-button @click="confirmOrder" style="float: right;margin-top: 20px" type="primary">确认订单</el-button>
      </el-col>
    </el-row>
    <!-- 修改全部弹出框 区间价格模式 -->
    <el-dialog title="修改" center :visible.sync="modifyTableVisible" width="950px">
      <el-table :data="modifyTable">
        <el-table-column prop="PRODUCT_NAME" label="产品名称" width="300"></el-table-column>
        <!-- <el-table-column label="产品编码" prop="PRODUCT_CODE"></el-table-column> -->
        <el-table-column label="单位" prop="TYPE_UNIT"></el-table-column>
        <el-table-column prop="REAL_PRICE" label="单价" width="150">
          <template slot-scope="scope">
            <el-row>
              <el-col :span="24">
                <el-input :placeholder="scope.row.REAL_PRICE" v-model="scope.row.REAL_PRICE" @focus="getPriceRow(scope.row)"
                  @change="setActualNumber(scope.row)" clearable></el-input>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column prop="BEFORE_TAX_PRICE" label="不含税单价" width="150">
          <template slot-scope="scope">
            <el-row>
              <el-col :span="24">
                <el-input v-model="scope.row.BEFORE_TAX_PRICE" disabled clearable></el-input>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column prop="REAL_COUNT" label="实收数量" width="150">
          <template slot-scope="scope">
            <el-row>
              <el-col :span="24">
                <el-input size="small" :placeholder="scope.row.REAL_COUNT" v-model="scope.row.REAL_COUNT" @focus="getCountRow(scope.row)"
                  @change="setValue" clearable></el-input>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close()">取 消</el-button>
        <el-button size="small" @click="submitModify" :loading="loading1">提 交</el-button>
      </div>
    </el-dialog>
    <!-- 修改弹出框 -->
    <el-row>
      <el-col>
        <el-dialog title="修改" center :visible.sync="editFormVisible" width="600px" :close-on-click-modal="false">
          <el-form :model="editForm" ref="editForm" size="small" :rules="rules">
            <el-form-item label="产品名称：" :label-width="formLabelWidth">
              <span>{{ this.editForm.PRODUCT_NAME }}</span>
            </el-form-item>
            <el-form-item label="单位：" :label-width="formLabelWidth">
              <label slot="label">单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位：</label>
              <span>{{ this.editForm.TYPE_UNIT }}</span>
            </el-form-item>
            <el-form-item label="单价：" :label-width="formLabelWidth" prop="REAL_PRICE">
              <label slot="label">单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价：</label>
              <el-input v-model="editForm.REAL_PRICE" @input="specialEditRealPriceInput"></el-input>
            </el-form-item>
            <el-form-item label="不含税单价：" :label-width="formLabelWidth" prop="BEFORE_TAX_PRICE">
              <el-input v-model="editForm.BEFORE_TAX_PRICE" disabled></el-input>
            </el-form-item>
            <el-form-item label="实收数量：" :label-width="formLabelWidth" prop="REAL_COUNT">
              <el-input v-model="editForm.REAL_COUNT"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="close('editForm')">取 消</el-button>
            <el-button size="small" @click="submitEdit('editForm')" :loading="loading1">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog title="上传批次报告" center :visible.sync="uploadBatchFormVisible" width="400px" :close-on-click-modal="false">
          <el-form size="small" ref="uploadBatchForm" :model="uploadBatchForm" label-width="120px">
            <el-form-item label="送检单位" prop="SUBMIT_UNIT">
              <el-input v-model="uploadBatchForm.SUBMIT_UNIT"></el-input>
            </el-form-item>
            <el-form-item label="检测报告" prop="TEST_UNIT">
              <el-input v-model="uploadBatchForm.TEST_UNIT"></el-input>
            </el-form-item>
            <el-form-item label="批次报告">
              <el-upload class="upload-demo" action="/uploadFile" :on-success="handleSuccess" :on-remove="handleRemove" name="qualification" multiple
                :file-list="fileList">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过5M</div>
              </el-upload>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="uploadBatchFormVisible = false">取 消</el-button>
            <el-button size="small" @click="$uploadBatch()" :loading="loading2">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog title="查看批次报告" center :visible.sync="查看批次报告模态框" width="400px" :close-on-click-modal="false">
          <el-form size="small" ref="查看批次报告模态框表单" :model="查看批次报告模态框表单" label-width="120px">
            <el-form-item label="送检单位" prop="SUBMIT_UNIT">
              <el-input v-model="查看批次报告模态框表单.SUBMIT_UNIT" disabled style="width: 200px"></el-input>
            </el-form-item>
            <el-form-item label="检测报告" prop="TEST_UNIT">
              <el-input v-model="查看批次报告模态框表单.TEST_UNIT" disabled style="width: 200px"></el-input>
            </el-form-item>
            <el-form-item label="批次报告">
              <el-button type="text" @click="下载批次报告()">下载报告</el-button>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="查看批次报告模态框 = false">取 消</el-button>
            <el-button size="small" @click="查看批次报告模态框 = false">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  historyOrderDetailFun, modifyOrderFun, supplierCondirmOrderFun, modifyAllOrderFun, uploadBatch, downloadBatchReport,
} from '@/assets/api/shopOrderManage';
import { frontEndFun } from '@/assets/api/frontFun';
import util from '@/assets/common/util';
import validation from '@/assets/common/validation';

export default {
  data() {
    return {
      fromName: ['shopConfirmOrderList'],
      toName: [],
      PAGE_ID: '10052', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 1005201: 0, 1005202: 0, 1005203: 0 }, // 功能ID 一旦规定不要轻易改动
      orderCode: sessionStorage.getItem('orderCode'),
      orderId: sessionStorage.getItem('orderId'),
      tableData: [],
      editFormVisible: false,
      modifyTableVisible: false,
      modifyTable: [],
      editForm: {},
      formLabelWidth: '120px',
      loading1: false,
      rules: {
        REAL_PRICE: [
          { required: true, message: '请输入单价', trigger: 'blur' },
        ],
        REAL_COUNT: [
          { required: true, message: '请输入实收数量', trigger: 'blur' },
        ],
      },
      titleData: [
        {
          SUPPLIER_NAME: '',
        },
      ],
      userPriceType: sessionStorage.getItem('PRICE_MODE'),
      uploadBatchFormVisible: false,
      uploadBatchForm: {},
      loading2: false,
      fileList: [],
      查看批次报告模态框: false,
      查看批次报告模态框表单: {},
    };
  },
  beforeRouteLeave(to, from, next) {
    // 离开页面前清除订单ID
    if (!this.toName.includes(to.name)) {
      sessionStorage.removeItem('orderId');
    }
    next();
  },
  beforeRouteEnter(to, from, next) {
    next((that) => {
      // 判断是否通过修改URL进入
      if (!that.fromName.includes(from.name) || !sessionStorage.getItem('orderId')) {
        that.$message.show({ text: '请从待确认订单进入详情', type: 'warning' });
        that.$router.go(-1);
      } else {
        that.queryTable();
        that.queryBeforeFun();
      }
    });
  },
  methods: {
    下载批次报告() {
      window.open(this.$util.getURLLocalHost(this.查看批次报告模态框表单.FILE_PATH), 'file');
    },
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      frontEndFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.forMenu(result, this.fun_dic);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // -----------------------------------拉取数据
    queryTable() {
      const params = {
        ID: Number(sessionStorage.getItem('orderId')),
      };
      historyOrderDetailFun(params).then((result) => {
        if (result[0].list.length !== 0) {
          this.tableData = result[0].list.map((item) => Object.assign(item, {
            TOTAL_FEE: item.TOTAL_FEE.toFixed(2),
            BEFORE_TAX_PRICE: Number(item.BEFORE_TAX_PRICE).toFixed(2),
            NEW_BEFORE_TAX_PRICE: Number((item.REAL_PRICE / (1 + item.TAX_RATE / 100)).toFixed(10)),
          }));
          this.modifyTable = util.deepCopy(this.tableData);
          this.titleData = result[0].title;
        } else {
          this.tableData = [];
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    openEditDialog(row) {
      this.editFormVisible = true;
      this.editForm = { ...row };
    },
    submitEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
          if (!reg.test(this.editForm.REAL_COUNT)) {
            this.$message.show({ text: '请输入正数订购数量', type: 'warning' });
            return false;
          }
          // if (this.editForm.TYPE_UNIT != 'KG' && this.editForm.TYPE_UNIT != 'kg') { // 如果不是
          if (!util.JudgmentUnit(this.editForm.TYPE_UNIT)) { // 如果不是
            const beInter = (this.editForm.REAL_COUNT % 1 === 0);
            if (beInter == false) {
              this.$message.show({ text: '单位不是KG的，只能输入整数', type: 'warning' });
              return false;
            }
          }
          if (!validation.价格正数验证(this.editForm.REAL_PRICE)) {
            this.$message.show({ text: '请输入单价', type: 'warning' });
            return false;
          }
          const updateParams = {
            ORDER_DETAIL_ID: Number(this.editForm.ID),
            PRODUCT_CODE: this.editForm.PRODUCT_CODE,
            ORDER_ID: sessionStorage.getItem('orderId'),
            PRODUCT_COUNT: Number(this.editForm.REAL_COUNT),
            PRICE: this.editForm.REAL_PRICE,
            BEFORE_TAX_PRICE: this.editForm.NEW_BEFORE_TAX_PRICE,
            TAX_RATE: this.editForm.TAX_RATE,
          };
          this.loading1 = true;
          modifyOrderFun(updateParams).then((result) => {
            this.$message.show({ text: '修改成功', type: 'success' });
            this.loading1 = false;
            this.editPriceFormVisible = false;
            this.editFormVisible = false;
            this.queryTable();
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            this.loading1 = false;
          });
        } else {
          return false;
        }
      });
    },
    close() {
      this.editFormVisible = false;
      this.modifyTableVisible = false;
    },
    modifyOrder() {
      this.modifyTableVisible = true;
    },
    getPriceRow(row) {
      this.productID = row.ORDER_DETAIL_ID;
    },
    setActualNumber(row) {
      if (!validation.价格正数验证(row.REAL_PRICE)) {
        this.$message.show({ text: '价格为大于零的数字', type: 'warning' });
        return false;
      }
      row.NEW_BEFORE_TAX_PRICE = Number((row.REAL_PRICE / (1 + row.TAX_RATE / 100)).toFixed(10));
      row.BEFORE_TAX_PRICE = row.NEW_BEFORE_TAX_PRICE.toFixed(2);
    },
    getCountRow(row) {
      this.productID = row.ORDER_DETAIL_ID;
      this.currentCount = row.PRODUCT_COUNT;
    },
    // 修改实收数量
    setValue(count) {
      if (!(/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/.test(count))) {
        this.$message.show({ text: '请输入正数实收数量', type: 'warning' });
        return false;
      }
    },
    submitModify() {
      if (!this.modifyTable.every((item) => validation.价格正数验证(item.REAL_PRICE))) {
        this.$message.show({ text: '价格为大于零的数字', type: 'warning' });
        return false;
      }
      const submitArr = this.modifyTable.map((item, index) => ({
        ORDER_DETAIL_ID: Number(item.ID),
        PRODUCT_CODE: Number(item.PRODUCT_CODE),
        PRODUCT_COUNT: Number(item.REAL_COUNT),
        PRICE: Number(item.REAL_PRICE),
        BEFORE_TAX_PRICE: item.NEW_BEFORE_TAX_PRICE,
        TAX_RATE: item.TAX_RATE,
      }));
      const params = {
        ORDER_ID: Number(sessionStorage.getItem('orderId')),
        ORDER_DETAILS: submitArr,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      modifyAllOrderFun(params).then((result) => {
        this.$message.show({ text: '修改成功', type: 'success' });
        this.loading1 = false;
        this.modifyTableVisible = false;
        this.queryTable();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.loading1 = false;
      });
    },
    confirmOrder() {
      const params = {
        ORDER_ID: Number(sessionStorage.getItem('orderId')),
      };
      supplierCondirmOrderFun(params).then((result) => {
        this.$message.show({ text: '确认成功', type: 'success' });
        this.$router.push({ name: 'shopConfirmOrderList' });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 上传批次报告
    showUploadBatch(row) {
      this.uploadBatchFormVisible = true;
      this.uploadBatchForm = { ...row, DETAIL_ID: row.ID };
    },
    handleSuccess(response, file, fileList) {
      this.fileList = fileList;
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
      this.file_name = '';
    },
    $uploadBatch() {
      this.loading2 = true;
      const params = {
        DETAIL_ID: this.uploadBatchForm.DETAIL_ID,
        PRODUCT_CODE: this.uploadBatchForm.PRODUCT_CODE,
        FILE_URL: this.fileList.map((item) => item.response.file_name),
        SUBMIT_UNIT: this.uploadBatchForm.SUBMIT_UNIT,
        TEST_UNIT: this.uploadBatchForm.TEST_UNIT,
      };
      uploadBatch(params).then((result) => {
        this.$message.show({ text: '上传批次报告成功', type: 'success' });
        this.loading2 = false;
        this.uploadBatchFormVisible = false;
        this.queryTable();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.loading2 = false;
      });
    },
    specialEditRealPriceInput(val) {
      val = val.replace(/[^0-9]*/, '');
      this.editForm.NEW_BEFORE_TAX_PRICE = Number((val / (1 + this.editForm.TAX_RATE / 100)).toFixed(10));
      this.editForm.BEFORE_TAX_PRICE = this.editForm.NEW_BEFORE_TAX_PRICE.toFixed(2);
    },
    downloadBatch(BATCH_REPORT_ID) {
      const params = {
        BATCH_REPORT_ID,
      };
      downloadBatchReport(params)
        .then((result) => {
          this.查看批次报告模态框表单 = { ...result[0] };
          this.查看批次报告模态框 = true;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
  },

};
</script>
<style scoped>
.inline-input {
  width: 300px;
}

ul {
  list-style: none;
  min-height: 50px;
  padding: 0;
}

li {
  margin-bottom: 0;
  line-height: 25px;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/shopOrderManage/supplierComfirmDetail.vue